<template>
  <vs-col vs-lg="12" vs-xs="12" class="p-1" id="frequency-chart">
    <vs-card :id="headerTitle" class="vs-con-loading__container">
      <div slot="header">
        <h3>
          {{ headerTitle }}
        </h3>
      </div>
      <div class="col">
        <vue-apex-charts
          v-if="visitFrequency.chartOptions.series[0].data.length && state"
          height="350"
          ref="visitFrequencyChart"
          :options="visitFrequency.chartOptions"
          :series="visitFrequency.chartOptions.series"
          :key="componentKey"
        ></vue-apex-charts>
      </div>
    </vs-card>
  </vs-col>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "Frequency",
  data: () => ({
    state: true,
    startDate: "",
    endDate: "",
    activeVisitPrompt: false,
    visitFrequency: {
      chartOptions: {
        chart: {
          id: "visit-frequency",
          type: "",
          height: 350,
        },
        dataLabels: {
          enabled: false,
        },

        markers: {
          size: 0,
          style: "hollow",
        },
        series: [
          {
            name: "",
            data: [],
          },
        ],
        xaxis: {
          categories: [],
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy",
          },
        },
        title: {
          align: "center",
          margin: 10,
          floating: true,
          style: {
            fontSize: "18px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
      },
      chartData: "",
      chartType: "",
      dateType: "",
      typeData: "",
      componentKey: 0,
    },
  }),
  props: {
    visitFrequencyParams: Object,
    headerTitle: String,
    tickets: Object,
  },
  watch: {
    tickets: function(newValue, oldValue) {

      this.startDate = this.$moment()
      .subtract(2, "months")
      .format("YYYY-MM-DD");
    this.endDate = this.$moment().format("YYYY-MM-DD");
    switch (this.visitFrequencyParams.periodical) {
      case "MONTHLY":
        this.visitFrequency.chartOptions.series[0].data = newValue.data;
        this.visitFrequency.chartOptions.series[0].name = this.$t(
          "Statistics.VisitFrequency.Queue"
        );
        this.visitFrequency.chartOptions.title.text = this.$t(
          "Statistics.VisitFrequency.Queue"
        );
        this.visitFrequency.chartOptions.xaxis.categories = newValue.labels;
        this.visitFrequency.chartOptions.chart.type = "area";
        this.visitFrequency.chartData = "queue";
        this.visitFrequency.typeData = "queue";

        break;
      case "YEARLY":
        this.visitFrequency.chartOptions.series[0].data = newValue.data;
        this.visitFrequency.chartOptions.series[0].name = this.$t(
          "Statistics.VisitFrequency.Queue"
        );
        this.visitFrequency.chartOptions.title.text = this.$t(
          "Statistics.VisitFrequency.Queue"
        );
        this.visitFrequency.chartOptions.xaxis.categories = newValue.labels.map(
          (e, i) => {
            return (
              this.$moment(newValue.labels[i].toString()).format("MMM") +
              " " +
              newValue.year[i]
            );
          }
        );
        this.visitFrequency.chartOptions.chart.type = "area";
        this.visitFrequency.chartData = "queue";
        this.visitFrequency.typeData = "queue";

        break;
    }
    this.forceRerender();
        }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    showLoading() {
      this.$vs.loading({
        container: "#" + this.headerTitle,
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#" + this.headerTitle + " > .con-vs-loading");
    },
    visitFrequencyPrompt() {
      this.activeVisitPrompt = true;
      this.reset();
    },
    reset() {
      this.visitFrequency.chartType = this.visitFrequency.chartOptions.chart.type;
      this.visitFrequency.dateType = this.visitFrequencyParams.periodical;
      this.visitFrequency.chartData = this.visitFrequency.typeData;
    },
  },
  components: {
    VueApexCharts,
  },
};
</script>

<style></style>
